/**************************************************
 * Nombre:       Seccion_PorMayor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Lineas from "./Componentes/Home_Lineas";
import Home_Indicadores from "./Componentes/Home_Indicadores";
import PorMayor_Portada from "./Componentes/PorMayor_Portada";
import PorMayor_Compra from "./Componentes/PorMayor_Compra";
import PorMayor_Franquisia from "./Componentes/PorMayor_Franquisia";
import PorMayor_Ventajas from "./Componentes/PorMayor_Ventajas";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_PorMayor = () => {
    const {sCell} = useResponsive()

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <PorMayor_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Lineas/>
            </Grid>

            <Grid id={'Formulario'} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 12}}>
                <PorMayor_Compra/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <PorMayor_Franquisia/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 12}}>
                <PorMayor_Ventajas/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Indicadores/>
            </Grid>

        </Grid>
    )

}
export default Seccion_PorMayor